import React from 'react';
export var InputGroupContext = /*#__PURE__*/React.createContext({});